import { render, staticRenderFns } from "./ProductDetail4.vue?vue&type=template&id=d5b432f8&scoped=true"
import script from "./ProductDetail4.vue?vue&type=script&lang=js"
export * from "./ProductDetail4.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail4.vue?vue&type=style&index=0&id=d5b432f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b432f8",
  null
  
)

export default component.exports